const withdrawals = require('./withdrawals');
const referralWithdrawal = require('./referralWithdrawals');
const referral = require('./referral');
const localeOptions = [
  { value: 'en', label: 'EN' },
  { value: 'bn', label: 'BN' }
];

const messages = {
  en: {
    referral: referral.en,
    withdrawals: withdrawals.en,
    referralWithdrawal: referralWithdrawal.en,
    common: {
      understoodContinue: 'I understand, continue',
      brand: 'BN Cash Crowd',
      add: 'Add',
      all: 'All',
      close: 'Close',
      refresh: 'Refresh',
      cancel: 'Cancel',
      version: 'Version',
      support: 'Contact support',
      supportLoading: 'Loading support contact…',
      supportTelegram: 'Join our Telegram support group',
      supportLoadFailed: 'Unable to load support. Tap to retry.',
      supportPending: 'Support contact is not configured yet',
      wallet: 'Wallet',
      record: 'Record'
    },
    nav: {
      home: 'Home',
      wallets: 'Wallets',
      earnings: 'Earnings',
      me: 'Me'
    },
    landing: {
      title: 'Earn commission with your bKash or Nagad wallet',
      copy: 'Bind an eligible wallet, let the platform process approved payments, and track every commission with clear formulas.',
      start: 'Start earning',
      signIn: 'Sign in',
      receiveCommission: 'Receive Money',
      receiveRateCopy: 'Plus {amount} fixed per completed receive order.',
      payoutCommission: 'Send Money',
      payoutRateCopy: 'Plus {amount} fixed per completed payout order.',
      activationMinimum: 'Activation minimum',
      activationCopy: 'Your wallet must hold at least this balance before it can run orders.',
      howItWorks: 'How it works',
      stepBind: 'Bind your wallet with wallet number and password/PIN.',
      stepOtp: 'Paste the full OTP SMS and complete balance activation.',
      stepTrack: 'Track wallet-level commission records and withdraw to another same-brand wallet.',
      protectedTitle: 'What is protected',
      protectedCommission: 'Every commission row shows the exact rate formula.',
      protectedFlow: 'Only platform-approved flows are allowed while the wallet is online.',
      protectedRisk: 'Non-platform outgoing transfers freeze the wallet for review.',
      protectedBaseline: 'Your baseline balance is visible after activation.'
    },
    auth: {
      signIn: 'Sign in',
      forgotPassword: 'Forgot password?',
      resetPassword: 'Reset password',
      resetCopy: 'Enter your registered email and request a code. The code expires in 10 minutes.',
      resetCodeSent: 'If this email is registered, a reset code has been sent.',
      passwordReset: 'Password reset. Please sign in with your new password.',
      backToLogin: 'Back to sign in',
      codeFormat: 'Enter the 6-digit email code.',
      createAccount: 'Create account',
      referralCode: 'Referral code',
      referralOptional: 'Optional',
      referralRequired: 'An invitation code is required.',
      policyUnavailable: 'Registration settings could not be loaded.',
      email: 'Email',
      emailPlaceholder: 'you@example.com',
      password: 'Password',
      passwordPlaceholder: 'Password',
      setPassword: 'Set password',
      confirmPassword: 'Confirm password',
      repeatPassword: 'Re-enter password',
      confirmPasswordRequired: 'Please confirm your password',
      passwordMismatch: 'Passwords do not match',
      code: 'Code',
      codePlaceholder: 'Email code',
      sendCode: 'Send code',
      resendCodeIn: 'Resend ({seconds}s)',
      createLink: 'Create an account',
      loginLink: 'Already have an account',
      emailRequired: 'Email is required',
      passwordRequired: 'Password is required',
      codeRequired: 'Code is required',
      enterEmailFirst: 'Enter your email first.',
      codeSent: 'Code sent.',
      signedIn: 'Signed in.',
      created: 'Account created. Please sign in.',
      signOut: 'Sign out'
    },
    home: {
      overview: 'Overview',
      title: 'Wallet earnings',
      customerId: 'ID',
      copyId: 'Copy ID',
      idCopied: 'ID copied',
      idCopyFailed: 'Unable to copy ID. Please try again.',
      today: 'Earned today',
      total: 'Total',
      walletCommission: 'Wallet commission',
      referralCommission: 'Total referral rewards',
      referralTitle: 'Referral earnings',
      referralDetails: 'Details',
      referralCopy: '{count} invited customers across L1 and L2.',
      referralRewardNote: 'Historical rewards. See details for the amount available to withdraw.',
      withdrawable: 'Withdrawable',
      boundWallets: 'Bound wallets',
      allWallets: 'All wallets',
      withdrawalInProgress: 'Withdrawal in progress',
      withdrawalInProgressCopy: '{count} withdrawal request(s) are still being processed.',
      noWallets: 'No wallets yet',
      recentRecords: 'Recent records'
    },
    wallet: {
      pending: {
        title: 'Pending bindings',
        verification: 'Verification incomplete',
        balance: 'Activation incomplete',
        verificationCopy: 'Wallet verification is not complete. This wallet is not active.',
        balanceCopy: 'Verification is complete. Check the balance to finish activation.',
        edit: 'Edit mobile & PIN',
        continue: 'Continue binding',
        cancel: 'Cancel binding',
        cancelConfirm: 'Cancel the unfinished binding for {wallet}? You can bind it again later.',
        keep: 'Keep binding'
      },
      title: 'Manage bound wallets',
      eyebrow: 'Wallets',
      copy: 'You can link multiple bKash and Nagad wallets to one account. Each wallet has its own baseline balance, daily commission records, and a balance you can withdraw.',
      list: 'Wallet list',
      search: 'Search wallet number or brand',
      records: 'Records',
      noRecords: 'No records',
      noWallets: 'No wallets yet',
      noWalletMatch: 'No matching wallets',
      bind: {
        eyebrow: 'Activation',
        title: 'Bind a wallet',
        stepWallet: 'Wallet',
        stepOtp: 'OTP',
        stepBalance: 'Balance',
        trust: 'The system only runs platform-approved receive and payout flows. Any other outgoing transfer freezes the wallet.',
        walletNo: 'Wallet no.',
        walletNoRequired: 'Wallet number is required',
        walletNoInvalid: 'Enter an 11-digit Bangladesh mobile number starting with 01.',
        password: 'Password / PIN',
        passwordPlaceholder: 'Wallet password or PIN',
        passwordRequired: 'Password / PIN is required',
        continue: 'Continue',
        saveAndResend: 'Save and resend OTP',
        editPinNote: 'For security, enter the PIN again. The saved PIN is never displayed.',
        otpCopy: 'Paste the full OTP SMS. Do not enter only the digits.',
        smsSample: 'Example: Your bKash verification code is 123456. Never share it with anyone. ABCDEF012345678',
        nagadSmsSample: 'Example: Your Nagad verification code is 1234 UID:abc123',
        smsPlaceholder: 'Paste full SMS here',
        submitOtp: 'Submit and detect',
        minimum: 'Activation minimum',
        balanceCopy: 'The wallet can join the receive and payout pools only after its balance reaches the activation minimum.',
        checkBalance: 'Check balance again'
      },
      toastSubmitted: 'Wallet submitted. Paste the OTP SMS next.',
      toastOtpResent: 'Mobile number and PIN updated. Paste the new OTP SMS.',
      toastOtp: 'OTP submitted. Check balance to activate.',
      toastOnline: 'Wallet is online.',
      toastLowBalance: 'Balance is still below the activation minimum.',
      toastCancelled: 'Binding cancelled.',
      offlineTitle: 'Take wallet offline?',
      offlineMessage: 'Take {wallet} offline? New business payouts stop. Incoming payments are limited to your remaining accounting balance, without the extra 200 BDT allowance. Orders already accepted will finish. There is no settlement or automatic payout. You can still request withdrawals separately.',
      offlineSubmitted: 'Wallet is offline for new business payouts.',
      resumeTitle: 'Resume wallet?',
      resumeMessage: 'Resume {wallet}? Normal receiving and new business payouts restart, including the normal extra 200 BDT receiving allowance. Account and wallet checks still apply.',
      resumeSubmitted: 'Normal wallet activity resumed.',
      businessOfflineNote: 'New business payouts are stopped. Eligible incoming payments are limited to your remaining accounting balance, without the extra 200 BDT allowance. Accepted orders finish; no settlement starts. Withdrawals remain separate.',
      legacyReceivePausedNote: 'Receiving is separately paused on this wallet. Resuming receiving removes only that pause. Offline or Resume does not change it.',
      pauseReceiveTitle: 'Pause receiving?',
      pauseReceiveMessage: 'Pause new Receive Money orders for wallet {wallet}? Send Money remains available. The wallet stays linked, and your funds and existing orders are unchanged. This does not start settlement or an automatic payout.',
      pauseReceiveSubmitted: 'Receiving paused.',
	      resumeReceiveTitle: 'Resume receiving?',
	      resumeReceiveMessage: 'Remove the separate receiving pause for {wallet}? Incoming payments remain subject to the current offline mode and account limits. This does not resume business payouts or change settlement.',
	      resumeReceiveSubmitted: 'Receiving resumed.',
	      cancelOfflineTitle: 'Cancel offline request?',
	      cancelOfflineMessage: 'Restore wallet {wallet}? Restoration is only possible within 1 hour of the offline request and before settlement begins. The server checks eligibility and whether the previous state can be safely restored.',
	      cancelOfflineSubmitted: 'Offline request cancelled.',
	      security: {
	        pinEyebrow: 'Wallet security',
	        pinTitle: 'Change PIN',
	        pinNote: 'Update the wallet PIN used by BN Cash. Use the latest PIN from your wallet app.',
	        newPin: 'New PIN',
	        newPinPlaceholder: 'Enter new wallet PIN',
	        confirmPin: 'Confirm PIN',
	        confirmPinPlaceholder: 'Re-enter new PIN',
	        pinRequired: 'PIN is required.',
	        pinMismatch: 'PINs do not match.',
	        savePin: 'Save PIN',
	        pinSaved: 'PIN updated.',
	        otpEyebrow: 'Wallet login',
	        otpTitle: 'OTP re-login',
	        otpNote: 'Send a new wallet SMS, then paste the complete latest SMS. Do not enter only the digits.',
	        sendOtp: 'Send SMS',
	        resendOtp: 'Send again',
	        fullSms: 'Full SMS',
	        verifyOtp: 'Verify and login',
	        otpSent: 'Wallet SMS sent. Paste the complete latest SMS.',
	        otpVerified: 'Wallet login updated.'
	      }
	    },
    card: {
      baseline: 'Baseline',
      remainingPrincipal: 'Remaining principal',
      commission: 'Commission',
      withdrawable: 'Withdrawable',
      withdrawableCommission: 'Withdrawable commission',
      withdrawablePrincipal: 'Withdrawable principal',
      riskDeduction: 'Risk deduction',
      records: 'Records',
      recharge: 'Recharge',
      withdraw: 'Withdraw',
      more: 'More wallet actions',
      offline: 'Go offline',
      resume: 'Resume',
      pauseReceive: 'Pause receiving',
      resumeReceive: 'Resume receiving',
	      resumePausedReceive: 'Resume paused receiving',
	      updatePin: 'Change PIN',
	      otpRelogin: 'OTP re-login',
	      walletBalance: 'Wallet balance',
      balanceUpdatedAt: 'Balance updated: {time} (Bangladesh time)',
      cancelOffline: 'Cancel offline',
      frozenAlert: 'Non-platform outgoing transfer detected. This wallet is frozen. Contact support.'
    },
    recharge: {
      eyebrow: 'Baseline top-up',
      title: 'Recharge wallet',
      note: 'Recharge your own wallet first, then enter the amount and transaction ID. We check the wallet transaction and process the recharge when it arrives and has not been settled against a receive order.',
      amount: 'Amount',
      amountPlaceholder: 'Recharge amount',
      amountInvalid: 'Enter an amount greater than zero with up to two decimals.',
      transactionId: 'Transaction ID',
      transactionPlaceholder: 'Wallet transaction ID',
      transactionRequired: 'Transaction ID is required.',
      submit: 'Submit recharge',
      approved: 'Recharge verified. Baseline updated.',
      pending: 'Recharge submitted for manual review.',
      waiting: 'Recharge submitted. Waiting for a matching wallet transaction.',
      rejected: 'This recharge was rejected. Please resubmit for review or contact support.',
      unknown: 'Unable to confirm recharge status. Please check your records or contact support.'
    },
    earnings: {
      eyebrow: 'Earnings',
      title: 'Commission records',
      receive: 'Receive',
      payout: 'Payout',
      last30Days: 'Last 30 days',
      trend: 'Earnings trend',
      allRecords: 'All records',
      noMore: 'No more records',
      walletFilter: 'Wallet filter',
      chooseWallet: 'Choose wallet',
      searchWallet: 'Search wallet number or brand',
      allWallets: 'All wallets',
      noWalletMatch: 'No matching wallets',
      from: 'From',
      to: 'To',
      apply: 'Apply',
      invalidDates: 'Select a valid date range up to 90 days.',
      totalAmount: 'Earnings in selected period',
      notWithdrawable: 'These are historical earnings, not your available withdrawal balance.',
      receiveAmount: 'Receive earnings',
      payoutAmount: 'Payout earnings',
      referralSeparate: 'Referral commission is tracked separately',
      viewReferral: 'View L1 / L2 referral earnings',
      records: 'Records',
      pagination: 'Record pages',
      noRecords: 'No records'
    },
      withdraw: {
      title: 'Withdraw',
      minimum: 'Minimum withdrawal request: {amount}.',
      maximum: 'Maximum withdrawal request: 50,000 BDT (including fee).',
      fee: 'Withdrawal fee: {amount}.',
      receiveAmount: 'You will receive: {amount}.',
      nagadWholeAmount: 'Nagad requires a whole BDT amount received after the fee.',
      invalidAmount: 'Enter a valid amount with up to two decimal places.',
      history: 'Withdrawal requests',
      allHistory: 'Withdrawal requests',
      allHistorySubtitle: 'All wallet withdrawal requests',
      reserved: 'Reserved for pending withdrawals',
      verifyingBalance: 'Verifying wallet balance…',
      insufficientAfterRetention: 'The remaining amount after retaining your wallet balance is below the withdrawal minimum.',
      platformOnly: 'Your wallet is unavailable. Its confirmed balance is excluded from this withdrawal. The remaining amount will be paid through another available payment channel; your wallet will not be used to pay.',
      retainedWalletBalance: '{amount} remains in your wallet and cannot be withdrawn right now. This is not a fee or an extra charge.',
      balanceUnknown: 'We cannot confirm your available withdrawal amount yet. Please refresh and try again.',
      paid: 'Paid',
      pending: 'Pending reserve',
      waiting: 'Waiting',
      processing: 'Processing',
      partial: 'Partially paid',
      succeeded: 'Paid in full',
      failed: 'Failed',
      manual: 'Manual review',
      legacy: 'Legacy request - payment unconfirmed',
      unknown: 'Unknown status',
      noRequests: 'No withdrawal requests',
      loadError: 'Unable to load withdrawal requests. Please refresh.',
      uncertain: 'Acceptance could not be confirmed. The request key is saved for this login session, including after closing or refreshing. Retry the same details or check withdrawal requests before changing them.',
      previous: 'Previous',
      next: 'Next',
      available: 'Available from this wallet',
      targetWallet: 'Target wallet',
      targetRequired: 'Target wallet is required',
      targetInvalid: 'Enter an 11-digit wallet number starting with 01.',
      storageError: 'Cannot safely save or clear this withdrawal request. Check request history and browser storage before retrying.',
      amount: 'Amount',
      amountRequired: 'Amount is required',
      note: 'Choose another {walletType} number. The request amount is deducted from your withdrawable balance. Your own wallet pays first; other wallets may pay the remainder to the same target in multiple payments.',
      submit: 'Submit withdraw',
        greaterThanZero: 'Enter an amount greater than zero.',
        exceedsBalance: 'Amount exceeds this wallet withdrawable balance.',
        submittedGeneric: 'Withdrawal request accepted, not yet confirmed paid.',
        submitted: 'Withdrawal request accepted: {requestNo}. Track payment progress below.'
    },
    me: {
      eyebrow: 'Account',
      userFallback: 'Crowd user',
      copy: 'Manage your BN Cash Crowd account and wallet rules.',
      ruleFlow: 'Only platform-approved receive and payout flows run while a wallet is online.',
      ruleBalance: 'Baseline balance and commission are tracked per wallet.',
      ruleWithdraw: 'Withdrawals are made from a selected wallet to another same-brand wallet.',
      ruleRisk: 'Non-platform outgoing transfers freeze the wallet and require support review.'
    },
    status: {
      withdrawSettling: 'Withdrawal processing',
      binding: 'Binding',
      needsBalance: 'Needs balance',
      running: 'Running',
      businessOffline: 'Offline: payouts stopped',
      receivePaused: 'Receiving paused',
      needsReview: 'Needs review',
      stopping: 'Stopping',
      settling: 'Settling',
      offline: 'Offline',
      frozen: 'Frozen',
      unknown: 'Unknown'
    },
    ledger: {
      receiveCommission: 'Receive Money',
      payoutCommission: 'Send Money',
      riskDeduction: 'Risk deduction',
      balanceAdjustment: 'Balance adjustment',
      settlementPayout: 'Settlement payout',
      sweepBack: 'Sweep back',
      withdraw: 'Withdraw',
      recharge: 'Recharge',
      walletPrefix: 'Wallet'
    },
    errors: {
      resetCodeLimit: 'Too many incorrect reset codes. Please try again in 10 minutes.',
      emailFormat: 'Enter a valid email address.',
      passwordTooLong: 'Password must be at most 72 bytes.',
      walletExists: 'This wallet already exists. Contact support to restore a deleted wallet.',
      invitationRequired: 'An invitation code is required.',
      referralInvalid: 'This referral code is invalid or inactive. Please check your invitation code.',
      referralUnavailable: 'Referrals are currently unavailable. Please try again later.',
      passwordFormat: 'Use at least 8 characters, including letters and numbers.',
      completeSms: 'Paste the complete original SMS, including the verification text at the end. Do not enter only the code.',
      walletVerification: 'Wallet verification failed. Check your PIN and use the complete latest SMS. Cancel and bind again if it still fails.',
      walletPinLocked: 'Your bKash PIN is locked. Stop retrying and contact bKash support to unlock it before binding again.',
      walletDeviceLocked: 'bKash has temporarily locked this device after multiple incorrect PIN attempts. Stop retrying and wait 24 hours from your last login attempt before binding again.',
      walletSmsFailed: 'Unable to send the wallet SMS. Please wait and try binding again.',
      bindingExpired: 'This binding session has expired. Cancel and bind the wallet again.',
      codeSubmitted: 'This code was already submitted. Cancel and bind again to request a new SMS.',
      walletBound: 'This wallet is already bound.',
      walletInUse: 'This wallet is already in use by the platform.',
      walletLimit: 'You have reached the wallet binding limit.',
      bindingLimitUnavailable: 'Unable to check the wallet binding limit. Please try again later.',
      tooManyRequests: 'Too many requests. Please wait before trying again.',
      emailCodeCooldown: 'Please wait {seconds} seconds before requesting another code.',
      loginLimit: 'Too many failed sign-in attempts. Try again in 15 minutes.',
      emailCodeLimit: "You have reached today's code limit. Try again tomorrow.",
      emailCodeFailed: 'Unable to send the email code. Please try again later.',
      accountFrozen: 'Your account is frozen. Please contact support.',
      verifyFirst: 'Complete wallet verification first.',
      balanceFailed: 'Unable to check the balance. Please try again later.',
      walletChanged: 'The wallet state has changed. Refresh and try again.',
      bindingUnavailable: 'Wallet binding is currently unavailable. Please try again later.',
      ussdRequired: 'This Nagad wallet requires USSD verification. Please use another wallet.',
      walletRequired: 'Wallet number and PIN are required.',
	      walletUnsupported: 'This wallet type is not supported.',
	      pinRequired: 'PIN is required.',
	      rechargeAmount: 'Enter a recharge amount greater than zero, up to two decimal places.',
      rechargeTransaction: 'Enter the wallet transaction ID.',
      rechargeDuplicate: 'This transaction ID was already submitted with a different amount.',
      withdrawAmount: 'Enter a withdrawal amount greater than zero.',
      withdrawMinimum: 'Withdrawal amount must cover at least 100 BDT payout plus the fee.',
      withdrawSourceDisabled: 'This wallet is disabled in the system. Contact support or choose another wallet.',
      targetWallet: 'Enter an 11-digit target wallet number starting with 01.',
      targetWalletType: 'The target wallet must use the same provider as the source wallet.',
      sameWallet: 'Choose a different wallet to receive the withdrawal.',
      timeout: 'The request timed out. Refresh to check its status before trying again.',
      999: 'Service is busy. Please try again.',
      1001: 'Email or password is incorrect.',
      1002: 'Record does not exist.',
      1003: 'This email is already registered.',
      1004: 'Please fill in the required information.',
      1006: 'The request is invalid. Check the information and try again.',
      1008: 'Your balance is not enough.',
      1009: 'This account is unavailable.',
      1016: 'This wallet status cannot complete the action.',
      1018: 'System error. Please try again later.',
      2001: 'The verification code is incorrect or expired.',
      401: 'Please sign in again.',
      1288: 'Please sign in again.',
      1289: 'Please sign in again.',
      requestFailed: 'Request failed.',
      receiveChangeFailed: 'Unable to change receiving status. Refresh and try again, or contact support.',
      businessStateFailed: 'Unable to change offline mode. Refresh and try again, or contact support.',
      cancelOfflineFailed: 'Unable to cancel the offline request. Refresh and try again, or contact support.',
      cancelOfflineSession: 'Wallet session could not be verified. Please contact support before restoring it.',
      cancelOfflineBalance: 'Wallet balance does not match the records. Please contact support before restoring it.',
      cancelOfflineMissing: 'Wallet does not exist.',
      cancelOfflineAccount: 'Your account is frozen or unavailable.',
      cancelOfflinePending: 'Only a pending offline request can be cancelled.',
      cancelOfflineExpired: 'The offline cancellation window has ended.',
      cancelOfflineSnapshot: 'This offline request has no safe restoration record. Older requests or wallets already disabled before going offline cannot be restored automatically. Please contact support.',
      cancelOfflineRestricted: 'Settlement, withdrawal or risk checks prevent restoring this wallet.',
      cancelOfflineUnavailable: 'The wallet is unavailable or has another restriction. Please contact support.',
      network: 'Network error. Please try again.',
      busy: 'Service is busy. Please try again.'
    }
  },
  bn: {
    referral: referral.bn,
    withdrawals: withdrawals.bn,
    referralWithdrawal: referralWithdrawal.bn,
    common: {
      understoodContinue: 'বুঝেছি, এগিয়ে যান',
      brand: 'BN Cash Crowd',
      add: 'যোগ করুন',
      all: 'সব',
      close: 'বন্ধ করুন',
      refresh: 'রিফ্রেশ',
      cancel: 'বাতিল',
      version: 'ভার্সন',
      support: 'সাপোর্টে যোগাযোগ করুন',
      supportLoading: 'সাপোর্টের তথ্য লোড হচ্ছে…',
      supportTelegram: 'আমাদের Telegram সাপোর্ট গ্রুপে যোগ দিন',
      supportLoadFailed: 'সাপোর্ট লোড করা যায়নি। আবার চেষ্টা করতে ট্যাপ করুন।',
      supportPending: 'সাপোর্টের যোগাযোগের তথ্য এখনও দেওয়া হয়নি',
      wallet: 'ওয়ালেট',
      record: 'রেকর্ড'
    },
    nav: {
      home: 'হোম',
      wallets: 'ওয়ালেট',
      earnings: 'আয়',
      me: 'আমার'
    },
    landing: {
      title: 'আপনার bKash বা Nagad ওয়ালেট দিয়ে কমিশন আয় করুন',
      copy: 'যোগ্য ওয়ালেট যুক্ত করুন, প্ল্যাটফর্ম অনুমোদিত পেমেন্ট প্রসেস করতে দিন এবং পরিষ্কার ফর্মুলায় প্রতিটি কমিশন দেখুন।',
      start: 'আয় শুরু করুন',
      signIn: 'সাইন ইন',
      receiveCommission: 'রিসিভ কমিশন',
      receiveRateCopy: 'প্রতি সম্পন্ন রিসিভ অর্ডারে অতিরিক্ত {amount} ফিক্সড।',
      payoutCommission: 'পেআউট কমিশন',
      payoutRateCopy: 'প্রতি সম্পন্ন পেআউট অর্ডারে অতিরিক্ত {amount} ফিক্সড।',
      activationMinimum: 'অ্যাক্টিভেশনের ন্যূনতম ব্যালেন্স',
      activationCopy: 'অর্ডার চালানোর আগে ওয়ালেটে অন্তত এই ব্যালেন্স থাকতে হবে।',
      howItWorks: 'কিভাবে কাজ করে',
      stepBind: 'ওয়ালেট নম্বর এবং পাসওয়ার্ড/PIN দিয়ে ওয়ালেট যুক্ত করুন।',
      stepOtp: 'সম্পূর্ণ OTP SMS পেস্ট করুন এবং ব্যালেন্স অ্যাক্টিভেশন শেষ করুন।',
      stepTrack: 'ওয়ালেটভিত্তিক কমিশন রেকর্ড দেখুন এবং একই ব্র্যান্ডের অন্য ওয়ালেটে টাকা তুলুন।',
      protectedTitle: 'যা সুরক্ষিত',
      protectedCommission: 'প্রতিটি কমিশন রোতে সঠিক রেট ফর্মুলা দেখা যায়।',
      protectedFlow: 'ওয়ালেট অনলাইন থাকলে শুধু প্ল্যাটফর্ম অনুমোদিত ফ্লো চলবে।',
      protectedRisk: 'প্ল্যাটফর্মের বাইরে টাকা পাঠালে ওয়ালেট রিভিউয়ের জন্য ফ্রিজ হবে।',
      protectedBaseline: 'অ্যাক্টিভেশনের পরে আপনার বেসলাইন ব্যালেন্স দেখা যায়।'
    },
    auth: {
      signIn: 'সাইন ইন',
      forgotPassword: 'পাসওয়ার্ড ভুলে গেছেন?',
      resetPassword: 'পাসওয়ার্ড রিসেট করুন',
      resetCopy: 'আপনার নিবন্ধিত ইমেইল দিয়ে কোডের অনুরোধ করুন। কোডটি ১০ মিনিট পর্যন্ত কার্যকর থাকবে।',
      resetCodeSent: 'এই ইমেইলটি নিবন্ধিত থাকলে পাসওয়ার্ড রিসেটের কোড পাঠানো হয়েছে।',
      passwordReset: 'পাসওয়ার্ড রিসেট হয়েছে। নতুন পাসওয়ার্ড দিয়ে সাইন ইন করুন।',
      backToLogin: 'সাইন ইনে ফিরে যান',
      codeFormat: 'ইমেইলে পাওয়া ৬ সংখ্যার কোড লিখুন।',
      createAccount: 'অ্যাকাউন্ট তৈরি করুন',
      referralCode: 'রেফারেল কোড',
      referralOptional: 'ঐচ্ছিক',
      referralRequired: 'একটি আমন্ত্রণ কোড প্রয়োজন।',
      policyUnavailable: 'নিবন্ধনের সেটিংস লোড করা যায়নি।',
      email: 'ইমেইল',
      emailPlaceholder: 'you@example.com',
      password: 'পাসওয়ার্ড',
      passwordPlaceholder: 'পাসওয়ার্ড',
      setPassword: 'পাসওয়ার্ড সেট করুন',
      confirmPassword: 'পাসওয়ার্ড নিশ্চিত করুন',
      repeatPassword: 'পাসওয়ার্ড আবার লিখুন',
      confirmPasswordRequired: 'আপনার পাসওয়ার্ড নিশ্চিত করুন',
      passwordMismatch: 'পাসওয়ার্ড দুটি মিলছে না',
      code: 'কোড',
      codePlaceholder: 'ইমেইল কোড',
      sendCode: 'কোড পাঠান',
      resendCodeIn: 'আবার ({seconds}s)',
      createLink: 'নতুন অ্যাকাউন্ট তৈরি করুন',
      loginLink: 'আগেই অ্যাকাউন্ট আছে',
      emailRequired: 'ইমেইল প্রয়োজন',
      passwordRequired: 'পাসওয়ার্ড প্রয়োজন',
      codeRequired: 'কোড প্রয়োজন',
      enterEmailFirst: 'আগে ইমেইল লিখুন।',
      codeSent: 'কোড পাঠানো হয়েছে।',
      signedIn: 'সাইন ইন হয়েছে।',
      created: 'অ্যাকাউন্ট তৈরি হয়েছে। অনুগ্রহ করে সাইন ইন করুন।',
      signOut: 'সাইন আউট'
    },
    home: {
      overview: 'ওভারভিউ',
      title: 'ওয়ালেট আয়',
      customerId: 'ID',
      copyId: 'আইডি কপি করুন',
      idCopied: 'আইডি কপি হয়েছে',
      idCopyFailed: 'আইডি কপি করা যায়নি। আবার চেষ্টা করুন।',
      today: 'আজকের আয়',
      total: 'মোট',
      walletCommission: 'ওয়ালেট কমিশন',
      referralCommission: 'মোট রেফারেল পুরস্কার',
      referralTitle: 'রেফারেল আয়',
      referralDetails: 'বিস্তারিত',
      referralCopy: 'L1 ও L2 মিলিয়ে {count} জন আমন্ত্রিত গ্রাহক।',
      referralRewardNote: 'এটি আগের সব পুরস্কারের হিসাব। তোলার যোগ্য পরিমাণ বিস্তারিত পাতায় দেখুন।',
      withdrawable: 'তোলার যোগ্য',
      boundWallets: 'যুক্ত ওয়ালেট',
      allWallets: 'সব ওয়ালেট',
      withdrawalInProgress: 'চলমান উত্তোলন',
      withdrawalInProgressCopy: '{count}টি উত্তোলন অনুরোধ এখনও প্রক্রিয়াধীন আছে।',
      noWallets: 'এখনও ওয়ালেট নেই',
      recentRecords: 'সাম্প্রতিক রেকর্ড'
    },
    wallet: {
      pending: {
        title: 'অসম্পূর্ণ সংযুক্তি',
        verification: 'যাচাই অসম্পূর্ণ',
        balance: 'সক্রিয়করণ অসম্পূর্ণ',
        verificationCopy: 'ওয়ালেট যাচাই সম্পূর্ণ হয়নি। এই ওয়ালেট সক্রিয় নয়।',
        balanceCopy: 'যাচাই সম্পূর্ণ হয়েছে। সক্রিয় করতে ব্যালেন্স যাচাই করুন।',
        edit: 'মোবাইল ও PIN পরিবর্তন করুন',
        continue: 'সংযুক্তি চালিয়ে যান',
        cancel: 'সংযুক্তি বাতিল করুন',
        cancelConfirm: '{wallet}-এর অসম্পূর্ণ সংযুক্তি বাতিল করবেন? পরে আবার যুক্ত করতে পারবেন।',
        keep: 'সংযুক্তি রাখুন'
      },
      title: 'যুক্ত ওয়ালেট পরিচালনা',
      eyebrow: 'ওয়ালেট',
      copy: 'একটি অ্যাকাউন্টে একাধিক বিকাশ নগদ ওয়ালেট যুক্ত করতে পারবেন। প্রতিটি ওয়ালেটের নিজস্ব বেসলাইন চ্যানেল আছে, দৈনিক এর কমিশন রেকর্ড এবং তোলার যোগ্য ব্যালেন্স থাকে যা আপনি তুলে নিতে পারবেন।',
      list: 'ওয়ালেট তালিকা',
      search: 'ওয়ালেট নম্বর বা ধরন খুঁজুন',
      records: 'রেকর্ড',
      noRecords: 'কোন রেকর্ড নেই',
      noWallets: 'এখনও ওয়ালেট নেই',
      noWalletMatch: 'কোনো মিল পাওয়া যায়নি',
      bind: {
        eyebrow: 'অ্যাক্টিভেশন',
        title: 'ওয়ালেট যুক্ত করুন',
        stepWallet: 'ওয়ালেট',
        stepOtp: 'OTP',
        stepBalance: 'ব্যালেন্স',
        trust: 'সিস্টেম শুধু প্ল্যাটফর্ম অনুমোদিত রিসিভ ও পেআউট ফ্লো চালায়। অন্য কোন টাকা পাঠানো হলে ওয়ালেট ফ্রিজ হবে।',
        walletNo: 'ওয়ালেট নম্বর',
        walletNoRequired: 'ওয়ালেট নম্বর প্রয়োজন',
        walletNoInvalid: '01 দিয়ে শুরু ১১ সংখ্যার বাংলাদেশি মোবাইল নম্বর লিখুন।',
        password: 'পাসওয়ার্ড / PIN',
        passwordPlaceholder: 'ওয়ালেট পাসওয়ার্ড বা PIN',
        passwordRequired: 'পাসওয়ার্ড / PIN প্রয়োজন',
        continue: 'চালিয়ে যান',
        saveAndResend: 'সংরক্ষণ করে আবার OTP পাঠান',
        editPinNote: 'নিরাপত্তার জন্য PIN আবার লিখুন। সংরক্ষিত PIN কখনও দেখানো হয় না।',
        otpCopy: 'সম্পূর্ণ OTP SMS পেস্ট করুন। শুধু সংখ্যাগুলো লিখবেন না।',
        smsSample: 'উদাহরণ: Your bKash verification code is 123456. Never share it with anyone. ABCDEF012345678',
        nagadSmsSample: 'উদাহরণ: Your Nagad verification code is 1234 UID:abc123',
        smsPlaceholder: 'সম্পূর্ণ SMS এখানে পেস্ট করুন',
        submitOtp: 'জমা দিয়ে শনাক্ত করুন',
        minimum: 'অ্যাক্টিভেশনের ন্যূনতম ব্যালেন্স',
        balanceCopy: 'ওয়ালেটের ব্যালেন্স ন্যূনতম সীমায় পৌঁছানোর পরেই এটি রিসিভ ও পেআউট পুলে যোগ হবে।',
        checkBalance: 'আবার ব্যালেন্স দেখুন'
      },
      toastSubmitted: 'ওয়ালেট জমা হয়েছে। এবার OTP SMS পেস্ট করুন।',
      toastOtpResent: 'মোবাইল নম্বর ও PIN পরিবর্তন হয়েছে। নতুন OTP SMS পেস্ট করুন।',
      toastOtp: 'OTP জমা হয়েছে। অ্যাক্টিভ করতে ব্যালেন্স দেখুন।',
      toastOnline: 'ওয়ালেট অনলাইন হয়েছে।',
      toastLowBalance: 'ব্যালেন্স এখনও অ্যাক্টিভেশনের ন্যূনতম সীমার নিচে।',
      toastCancelled: 'ওয়ালেট যুক্ত করা বাতিল হয়েছে।',
      offlineTitle: 'ওয়ালেট অফলাইন করবেন?',
      offlineMessage: '{wallet} অফলাইন করবেন? নতুন ব্যবসায়িক পেআউট বন্ধ হবে। অতিরিক্ত 200 BDT সীমা ছাড়া আপনার হিসাবের অবশিষ্ট ব্যালেন্স পর্যন্ত টাকা গ্রহণ করা যাবে। ইতিমধ্যে গৃহীত অর্ডারগুলো শেষ হবে। কোনো সেটেলমেন্ট বা স্বয়ংক্রিয় পেআউট শুরু হবে না। আপনি আলাদাভাবে টাকা তোলার অনুরোধ করতে পারবেন।',
      offlineSubmitted: 'নতুন ব্যবসায়িক পেআউটের জন্য ওয়ালেট অফলাইন হয়েছে।',
      resumeTitle: 'ওয়ালেট আবার চালু করবেন?',
      resumeMessage: '{wallet} আবার চালু করবেন? স্বাভাবিক টাকা গ্রহণ ও নতুন ব্যবসায়িক পেআউট শুরু হবে এবং টাকা গ্রহণের অতিরিক্ত 200 BDT সীমা ফিরে আসবে। অ্যাকাউন্ট ও ওয়ালেটের যাচাই প্রযোজ্য থাকবে।',
      resumeSubmitted: 'ওয়ালেটের স্বাভাবিক কার্যক্রম আবার চালু হয়েছে।',
      businessOfflineNote: 'নতুন ব্যবসায়িক পেআউট বন্ধ আছে। অতিরিক্ত 200 BDT সীমা ছাড়া হিসাবের অবশিষ্ট ব্যালেন্স পর্যন্ত যোগ্য পেমেন্ট গ্রহণ করা যাবে। গৃহীত অর্ডার শেষ হবে; সেটেলমেন্ট শুরু হবে না। টাকা তোলার অনুরোধ আলাদা থাকবে।',
      legacyReceivePausedNote: 'এই ওয়ালেটে টাকা গ্রহণ আলাদাভাবে বন্ধ আছে। এই বিরতি সরাতে বন্ধ থাকা টাকা গ্রহণ চালু করুন। অফলাইন বা আবার চালু করলে এই বিরতি বদলাবে না।',
      pauseReceiveTitle: 'টাকা গ্রহণ বন্ধ রাখবেন?',
      pauseReceiveMessage: 'ওয়ালেট {wallet}-এ নতুন Receive Money অর্ডার নেওয়া বন্ধ রাখবেন? Send Money চালু থাকবে। ওয়ালেট সংযুক্ত থাকবে এবং আপনার অর্থ ও চলমান অর্ডার অপরিবর্তিত থাকবে। এতে সেটেলমেন্ট বা স্বয়ংক্রিয় পেআউট শুরু হবে না।',
      pauseReceiveSubmitted: 'টাকা গ্রহণ আপাতত বন্ধ আছে।',
	      resumeReceiveTitle: 'টাকা গ্রহণ আবার চালু করবেন?',
	      resumeReceiveMessage: '{wallet}-এ টাকা গ্রহণের আলাদা বিরতি সরাবেন? টাকা গ্রহণের ক্ষেত্রে বর্তমান অফলাইন মোড ও অ্যাকাউন্টের সীমা প্রযোজ্য থাকবে। এতে ব্যবসায়িক পেআউট চালু হবে না এবং সেটেলমেন্ট বদলাবে না।',
	      resumeReceiveSubmitted: 'টাকা গ্রহণ আবার চালু হয়েছে।',
	      cancelOfflineTitle: 'অফলাইন অনুরোধ বাতিল করবেন?',
	      cancelOfflineMessage: 'ওয়ালেট {wallet} পুনরায় চালু করবেন? অফলাইন অনুরোধের ১ ঘণ্টার মধ্যে এবং সেটেলমেন্ট শুরু হওয়ার আগেই শুধু পুনরুদ্ধার সম্ভব। সার্ভার যোগ্যতা এবং আগের অবস্থায় নিরাপদে ফিরিয়ে নেওয়া সম্ভব কি না যাচাই করবে।',
	      cancelOfflineSubmitted: 'অফলাইন অনুরোধ বাতিল হয়েছে।',
	      security: {
	        pinEyebrow: 'ওয়ালেট নিরাপত্তা',
	        pinTitle: 'PIN পরিবর্তন করুন',
	        pinNote: 'BN Cash যে ওয়ালেট PIN ব্যবহার করবে সেটি আপডেট করুন। আপনার ওয়ালেট অ্যাপের সর্বশেষ PIN দিন।',
	        newPin: 'নতুন PIN',
	        newPinPlaceholder: 'নতুন ওয়ালেট PIN লিখুন',
	        confirmPin: 'PIN নিশ্চিত করুন',
	        confirmPinPlaceholder: 'নতুন PIN আবার লিখুন',
	        pinRequired: 'PIN প্রয়োজন।',
	        pinMismatch: 'PIN মিলছে না।',
	        savePin: 'PIN সংরক্ষণ করুন',
	        pinSaved: 'PIN আপডেট হয়েছে।',
	        otpEyebrow: 'ওয়ালেট লগইন',
	        otpTitle: 'OTP দিয়ে আবার লগইন',
	        otpNote: 'নতুন ওয়ালেট SMS পাঠান, তারপর সর্বশেষ সম্পূর্ণ SMS পেস্ট করুন। শুধু সংখ্যাগুলো লিখবেন না।',
	        sendOtp: 'SMS পাঠান',
	        resendOtp: 'আবার পাঠান',
	        fullSms: 'সম্পূর্ণ SMS',
	        verifyOtp: 'যাচাই করে লগইন করুন',
	        otpSent: 'ওয়ালেট SMS পাঠানো হয়েছে। সর্বশেষ সম্পূর্ণ SMS পেস্ট করুন।',
	        otpVerified: 'ওয়ালেট লগইন আপডেট হয়েছে।'
	      }
	    },
    card: {
      baseline: 'বেসলাইন',
      remainingPrincipal: 'অবশিষ্ট মূলধন',
      commission: 'কমিশন',
      withdrawable: 'তোলার যোগ্য',
      withdrawableCommission: 'উত্তোলনযোগ্য কমিশন',
      withdrawablePrincipal: 'উত্তোলনযোগ্য মূলধন',
      riskDeduction: 'ঝুঁকি কর্তন',
      records: 'রেকর্ড',
      recharge: 'রিচার্জ',
      withdraw: 'টাকা তুলুন',
      more: 'ওয়ালেটের আরও কাজ',
      offline: 'অফলাইন করুন',
      resume: 'আবার চালু করুন',
      pauseReceive: 'টাকা গ্রহণ বন্ধ রাখুন',
      resumeReceive: 'টাকা গ্রহণ চালু করুন',
	      resumePausedReceive: 'বন্ধ থাকা টাকা গ্রহণ চালু করুন',
	      updatePin: 'PIN পরিবর্তন',
	      otpRelogin: 'OTP লগইন',
	      walletBalance: 'ওয়ালেটের ব্যালেন্স',
      balanceUpdatedAt: 'ব্যালেন্স হালনাগাদ: {time} (বাংলাদেশ সময়)',
      cancelOffline: 'অফলাইন বাতিল',
      frozenAlert: 'প্ল্যাটফর্মের বাইরে টাকা পাঠানো শনাক্ত হয়েছে। এই ওয়ালেট ফ্রিজ করা হয়েছে। সাপোর্টে যোগাযোগ করুন।'
    },
    recharge: {
      eyebrow: 'বেসলাইন টপ-আপ',
      title: 'ওয়ালেট রিচার্জ',
      note: 'আগে আপনার নিজের ওয়ালেটে টাকা যোগ করুন, তারপর পরিমাণ ও ট্রানজ্যাকশন ID লিখুন। মিল থাকা ওয়ালেট ট্রানজ্যাকশন পাওয়া গেলে এবং তা রিসিভ অর্ডারে নিষ্পত্তি না হলে রিচার্জ প্রক্রিয়া করা হবে।',
      amount: 'পরিমাণ',
      amountPlaceholder: 'রিচার্জের পরিমাণ',
      amountInvalid: 'সর্বোচ্চ দুই দশমিকসহ শূন্যের বেশি পরিমাণ লিখুন।',
      transactionId: 'ট্রানজ্যাকশন ID',
      transactionPlaceholder: 'ওয়ালেট ট্রানজ্যাকশন ID',
      transactionRequired: 'ট্রানজ্যাকশন ID প্রয়োজন।',
      submit: 'রিচার্জ জমা দিন',
      approved: 'রিচার্জ যাচাই হয়েছে। বেসলাইন আপডেট হয়েছে।',
      pending: 'রিচার্জ জমা হয়েছে। অ্যাডমিনের পর্যালোচনার অপেক্ষায় আছে।',
      waiting: 'রিচার্জ জমা হয়েছে। ওয়ালেটের লেনদেন মেলার অপেক্ষায় আছে।',
      rejected: 'এই রিচার্জ প্রত্যাখ্যান করা হয়েছে। আবার জমা দিন অথবা সাপোর্টে যোগাযোগ করুন।',
      unknown: 'রিচার্জের অবস্থা নিশ্চিত করা যায়নি। রেকর্ড দেখুন অথবা সাপোর্টে যোগাযোগ করুন।'
    },
    earnings: {
      eyebrow: 'আয়',
      title: 'কমিশন রেকর্ড',
      receive: 'রিসিভ',
      payout: 'পেআউট',
      last30Days: 'শেষ ৩০ দিন',
      trend: 'আয়ের ট্রেন্ড',
      allRecords: 'সব রেকর্ড',
      noMore: 'আর রেকর্ড নেই',
      walletFilter: 'ওয়ালেট ফিল্টার',
      chooseWallet: 'ওয়ালেট বাছুন',
      searchWallet: 'ওয়ালেট নম্বর বা ব্র্যান্ড খুঁজুন',
      allWallets: 'সব ওয়ালেট',
      noWalletMatch: 'মিল পাওয়া যায়নি',
      from: 'শুরু',
      to: 'শেষ',
      apply: 'প্রয়োগ',
      invalidDates: '৯০ দিনের মধ্যে সঠিক তারিখ বাছুন।',
      totalAmount: 'নির্বাচিত সময়ের আয়',
      notWithdrawable: 'এটি আগের আয়ের হিসাব, বর্তমানে তোলার যোগ্য ব্যালেন্স নয়।',
      receiveAmount: 'রিসিভ আয়',
      payoutAmount: 'পেআউট আয়',
      referralSeparate: 'রেফারেল কমিশন আলাদাভাবে দেখা হয়',
      viewReferral: 'L1 / L2 রেফারেল আয় দেখুন',
      records: 'রেকর্ড',
      pagination: 'রেকর্ড পেজ',
      noRecords: 'রেকর্ড নেই'
    },
      withdraw: {
      title: 'টাকা তুলুন',
      minimum: 'টাকা তোলার অনুরোধের সর্বনিম্ন পরিমাণ {amount}।',
      maximum: 'প্রতি উত্তোলনের সর্বোচ্চ পরিমাণ ৫০,০০০ BDT (ফিসহ)।',
      fee: 'টাকা তোলার ফি: {amount}।',
      receiveAmount: 'আপনি পাবেন: {amount}।',
      nagadWholeAmount: 'Nagad-এর জন্য ফি বাদে প্রাপ্ত পরিমাণ পূর্ণ BDT হতে হবে।',
      invalidAmount: 'সর্বোচ্চ দুই দশমিক ঘরসহ সঠিক পরিমাণ লিখুন।',
      history: 'টাকা তোলার অনুরোধসমূহ',
      allHistory: 'টাকা তোলার অনুরোধসমূহ',
      allHistorySubtitle: 'সব ওয়ালেটের টাকা তোলার অনুরোধ',
      reserved: 'অপেক্ষমাণ উত্তোলনের জন্য সংরক্ষিত',
      verifyingBalance: 'ওয়ালেটের ব্যালেন্স যাচাই করা হচ্ছে…',
      insufficientAfterRetention: 'ওয়ালেটের ব্যালেন্স রেখে দেওয়ার পর বাকি অর্থ উত্তোলনের ন্যূনতম সীমার চেয়ে কম।',
      platformOnly: 'আপনার ওয়ালেট বর্তমানে ব্যবহারযোগ্য নয়। এই উত্তোলন থেকে ওয়ালেটে থাকা নিশ্চিত ব্যালেন্স বাদ দেওয়া হয়েছে। বাকি অর্থ অন্য সচল পেমেন্ট চ্যানেল দিয়ে পাঠানো হবে; এই ওয়ালেট থেকে টাকা পাঠানো হবে না।',
      retainedWalletBalance: '{amount} আপনার ওয়ালেটে রয়ে গেছে এবং এখন তোলা যাবে না। এটি কোনো ফি বা অতিরিক্ত চার্জ নয়।',
      balanceUnknown: 'এখন কত টাকা তোলা যাবে তা নিশ্চিত করা যাচ্ছে না। রিফ্রেশ করে আবার চেষ্টা করুন।',
      paid: 'পরিশোধিত',
      pending: 'অপেক্ষমাণ সংরক্ষিত অর্থ',
      waiting: 'অপেক্ষায়',
      processing: 'প্রক্রিয়াধীন',
      partial: 'আংশিক পরিশোধিত',
      succeeded: 'সম্পূর্ণ পরিশোধিত',
      failed: 'ব্যর্থ',
      manual: 'ম্যানুয়াল পর্যালোচনা',
      legacy: 'পুরোনো অনুরোধ - পরিশোধ নিশ্চিত নয়',
      unknown: 'অজানা অবস্থা',
      noRequests: 'টাকা তোলার কোনো অনুরোধ নেই',
      loadError: 'টাকা তোলার অনুরোধ লোড করা যায়নি। রিফ্রেশ করুন।',
      uncertain: 'অনুরোধ গ্রহণ নিশ্চিত করা যায়নি। এই লগইন সেশনে বন্ধ বা রিফ্রেশ করার পরও রিকোয়েস্ট কী সংরক্ষিত থাকবে। একই তথ্য দিয়ে আবার চেষ্টা করুন অথবা তথ্য বদলানোর আগে অনুরোধের তালিকা দেখুন।',
      previous: 'আগের',
      next: 'পরের',
      available: 'এই ওয়ালেট থেকে পাওয়া যাবে',
      targetWallet: 'টার্গেট ওয়ালেট',
      targetRequired: 'টার্গেট ওয়ালেট প্রয়োজন',
      targetInvalid: '01 দিয়ে শুরু হওয়া ১১ সংখ্যার ওয়ালেট নম্বর লিখুন।',
      storageError: 'এই অনুরোধ নিরাপদে সংরক্ষণ বা মুছতে পারা যায়নি। আবার চেষ্টা করার আগে অনুরোধের তালিকা ও ব্রাউজার স্টোরেজ পরীক্ষা করুন।',
      amount: 'পরিমাণ',
      amountRequired: 'পরিমাণ প্রয়োজন',
      note: 'অন্য একটি {walletType} নম্বর বেছে নিন। অনুরোধের পরিমাণ আপনার তোলার যোগ্য ব্যালেন্স থেকে কাটা হবে। প্রথমে আপনার নিজের ওয়ালেট থেকে, তারপর প্রয়োজনে অন্য ওয়ালেট থেকে একই নম্বরে একাধিক পেমেন্ট হবে।',
      submit: 'তোলার অনুরোধ জমা দিন',
      greaterThanZero: 'শূন্যের বেশি পরিমাণ লিখুন।',
      exceedsBalance: 'পরিমাণ এই ওয়ালেটের তোলার যোগ্য ব্যালেন্সের বেশি।',
      submittedGeneric: 'টাকা তোলার অনুরোধ গৃহীত হয়েছে, পরিশোধ এখনও নিশ্চিত নয়।',
      submitted: 'টাকা তোলার অনুরোধ গৃহীত: {requestNo}। নিচে পরিশোধের অগ্রগতি দেখুন।'
    },
    me: {
      eyebrow: 'অ্যাকাউন্ট',
      userFallback: 'Crowd user',
      copy: 'আপনার BN Cash Crowd অ্যাকাউন্ট এবং ওয়ালেট নিয়ম পরিচালনা করুন।',
      ruleFlow: 'ওয়ালেট অনলাইন থাকলে শুধু প্ল্যাটফর্ম অনুমোদিত রিসিভ ও পেআউট ফ্লো চলবে।',
      ruleBalance: 'বেসলাইন ব্যালেন্স এবং কমিশন প্রতি ওয়ালেটে আলাদাভাবে ট্র্যাক হয়।',
      ruleWithdraw: 'নির্বাচিত ওয়ালেট থেকে একই ব্র্যান্ডের অন্য ওয়ালেটে টাকা তোলা যায়।',
      ruleRisk: 'প্ল্যাটফর্মের বাইরে টাকা পাঠালে ওয়ালেট ফ্রিজ হবে এবং সাপোর্ট রিভিউ লাগবে।'
    },
    status: {
      binding: 'যুক্ত হচ্ছে',
      withdrawSettling: 'টাকা তোলা প্রক্রিয়াধীন',
      needsBalance: 'ব্যালেন্স প্রয়োজন',
      running: 'চলমান',
      businessOffline: 'অফলাইন: পেআউট বন্ধ',
      receivePaused: 'টাকা গ্রহণ বন্ধ আছে',
      needsReview: 'পর্যালোচনা প্রয়োজন',
      stopping: 'বন্ধ হচ্ছে',
      settling: 'সেটেল হচ্ছে',
      offline: 'অফলাইন',
      frozen: 'ফ্রিজ',
      unknown: 'অজানা'
    },
    ledger: {
      receiveCommission: 'রিসিভ কমিশন',
      payoutCommission: 'পেআউট কমিশন',
      riskDeduction: 'ঝুঁকি কর্তন',
      balanceAdjustment: 'ব্যালেন্স সমন্বয়',
      settlementPayout: 'সেটেলমেন্ট পেআউট',
      sweepBack: 'সুইপ ব্যাক',
      withdraw: 'টাকা তোলা',
      recharge: 'রিচার্জ',
      walletPrefix: 'ওয়ালেট'
    },
    errors: {
      resetCodeLimit: 'অনেকবার ভুল রিসেট কোড দেওয়া হয়েছে। ১০ মিনিট পরে আবার চেষ্টা করুন।',
      emailFormat: 'সঠিক ইমেইল ঠিকানা লিখুন।',
      passwordTooLong: 'পাসওয়ার্ড সর্বোচ্চ ৭২ বাইট হতে পারে।',
      walletExists: 'এই ওয়ালেটটি ইতিমধ্যে রয়েছে। মুছে ফেলা ওয়ালেট পুনরুদ্ধার করতে সহায়তায় যোগাযোগ করুন।',
      invitationRequired: 'একটি আমন্ত্রণ কোড প্রয়োজন।',
      referralInvalid: 'রেফারেল কোডটি ভুল বা বন্ধ আছে। অনুগ্রহ করে আমন্ত্রণ কোডটি যাচাই করুন।',
      referralUnavailable: 'রেফারেল বর্তমানে বন্ধ আছে। পরে আবার চেষ্টা করুন।',
      passwordFormat: 'অক্ষর ও সংখ্যা মিলিয়ে অন্তত ৮ অক্ষরের পাসওয়ার্ড দিন।',
      completeSms: 'শেষের যাচাইকরণ অংশসহ সম্পূর্ণ মূল SMS পেস্ট করুন। শুধু কোড লিখবেন না।',
      walletVerification: 'ওয়ালেট যাচাই ব্যর্থ হয়েছে। PIN এবং সর্বশেষ সম্পূর্ণ SMS যাচাই করুন। আবার ব্যর্থ হলে বাতিল করে পুনরায় যুক্ত করুন।',
      walletPinLocked: 'আপনার bKash PIN লক হয়ে গেছে। বারবার চেষ্টা করবেন না। PIN আনলক করতে bKash সহায়তায় যোগাযোগ করুন, তারপর আবার ওয়ালেট যুক্ত করুন।',
      walletDeviceLocked: 'একাধিকবার ভুল PIN দেওয়ায় bKash এই ডিভাইসটি সাময়িকভাবে লক করেছে। বারবার চেষ্টা করবেন না। শেষবার লগইন করার চেষ্টার পর ২৪ ঘণ্টা অপেক্ষা করে আবার ওয়ালেট যুক্ত করুন।',
      walletSmsFailed: 'ওয়ালেটের SMS পাঠানো যায়নি। কিছুক্ষণ পরে আবার যুক্ত করার চেষ্টা করুন।',
      bindingExpired: 'এই সেশনের মেয়াদ শেষ। বাতিল করে ওয়ালেটটি আবার যুক্ত করুন।',
      codeSubmitted: 'এই কোড ইতিমধ্যে জমা দেওয়া হয়েছে। নতুন SMS পেতে বাতিল করে আবার যুক্ত করুন।',
      walletBound: 'এই ওয়ালেট ইতিমধ্যে যুক্ত আছে।',
      walletInUse: 'এই ওয়ালেটটি প্ল্যাটফর্মে ব্যবহৃত হচ্ছে।',
      walletLimit: 'সর্বোচ্চ সংখ্যক ওয়ালেট যুক্ত করা হয়েছে।',
      bindingLimitUnavailable: 'ওয়ালেট যুক্ত করার সীমা যাচাই করা যায়নি। অনুগ্রহ করে পরে আবার চেষ্টা করুন।',
      tooManyRequests: 'অনেকবার অনুরোধ করা হয়েছে। কিছুক্ষণ পরে আবার চেষ্টা করুন।',
      emailCodeCooldown: 'আবার কোড চাইতে {seconds} সেকেন্ড অপেক্ষা করুন।',
      loginLimit: 'অনেকবার লগইন ব্যর্থ হয়েছে। ১৫ মিনিট পরে আবার চেষ্টা করুন।',
      emailCodeLimit: 'আজকের কোড পাঠানোর সীমা শেষ। আগামীকাল আবার চেষ্টা করুন।',
      emailCodeFailed: 'ইমেইল কোড পাঠানো যায়নি। পরে আবার চেষ্টা করুন।',
      accountFrozen: 'আপনার অ্যাকাউন্ট স্থগিত আছে। সাপোর্টে যোগাযোগ করুন।',
      verifyFirst: 'আগে ওয়ালেট যাচাই সম্পূর্ণ করুন।',
      balanceFailed: 'ব্যালেন্স যাচাই করা যায়নি। পরে আবার চেষ্টা করুন।',
      walletChanged: 'ওয়ালেটের অবস্থা বদলেছে। রিফ্রেশ করে আবার চেষ্টা করুন।',
      bindingUnavailable: 'এখন ওয়ালেট যুক্ত করা যাচ্ছে না। পরে আবার চেষ্টা করুন।',
      ussdRequired: 'এই Nagad ওয়ালেটের USSD যাচাই প্রয়োজন। অন্য ওয়ালেট ব্যবহার করুন।',
      walletRequired: 'ওয়ালেট নম্বর ও PIN প্রয়োজন।',
	      walletUnsupported: 'এই ধরনের ওয়ালেট সমর্থিত নয়।',
	      pinRequired: 'PIN প্রয়োজন।',
	      rechargeAmount: 'শূন্যের বেশি রিচার্জ পরিমাণ দিন, সর্বোচ্চ দুই দশমিক পর্যন্ত।',
      rechargeTransaction: 'ওয়ালেট ট্রানজ্যাকশন ID দিন।',
      rechargeDuplicate: 'এই ট্রানজ্যাকশন ID আগে ভিন্ন পরিমাণে জমা দেওয়া হয়েছে।',
      withdrawAmount: 'শূন্যের বেশি উত্তোলনের পরিমাণ দিন।',
      withdrawMinimum: 'উত্তোলনের পরিমাণে অন্তত 100 BDT পেমেন্ট ও ফি থাকতে হবে।',
      withdrawSourceDisabled: 'এই ওয়ালেটটি সিস্টেমে নিষ্ক্রিয়। সহায়তায় যোগাযোগ করুন অথবা অন্য ওয়ালেট বেছে নিন।',
      targetWallet: '01 দিয়ে শুরু হওয়া ১১ সংখ্যার প্রাপক ওয়ালেট নম্বর দিন।',
      targetWalletType: 'প্রাপক ও উৎস ওয়ালেট একই সেবাদাতার হতে হবে।',
      sameWallet: 'উত্তোলনের টাকা পেতে অন্য ওয়ালেট বেছে নিন।',
      timeout: 'অনুরোধের সময় শেষ হয়েছে। আবার চেষ্টা করার আগে রিফ্রেশ করে অবস্থা দেখুন।',
      999: 'সার্ভিস ব্যস্ত। আবার চেষ্টা করুন।',
      1001: 'ইমেইল বা পাসওয়ার্ড সঠিক নয়।',
      1002: 'রেকর্ড পাওয়া যায়নি।',
      1003: 'এই ইমেইলটি আগে থেকেই নিবন্ধিত।',
      1004: 'প্রয়োজনীয় তথ্য পূরণ করুন।',
      1006: 'অনুরোধটি সঠিক নয়। তথ্য দেখে আবার চেষ্টা করুন।',
      1008: 'আপনার ব্যালেন্স যথেষ্ট নয়।',
      1009: 'এই অ্যাকাউন্ট ব্যবহার করা যাচ্ছে না।',
      1016: 'এই ওয়ালেট অবস্থায় কাজটি করা যাবে না।',
      1018: 'সিস্টেম সমস্যা। পরে আবার চেষ্টা করুন।',
      2001: 'ভেরিফিকেশন কোড সঠিক নয় বা মেয়াদ শেষ।',
      401: 'আবার সাইন ইন করুন।',
      1288: 'আবার সাইন ইন করুন।',
      1289: 'আবার সাইন ইন করুন।',
      requestFailed: 'অনুরোধ ব্যর্থ হয়েছে।',
      receiveChangeFailed: 'টাকা গ্রহণের অবস্থা পরিবর্তন করা যায়নি। রিফ্রেশ করে আবার চেষ্টা করুন অথবা সহায়তায় যোগাযোগ করুন।',
      businessStateFailed: 'অফলাইন মোড পরিবর্তন করা যায়নি। রিফ্রেশ করে আবার চেষ্টা করুন অথবা সহায়তায় যোগাযোগ করুন।',
      cancelOfflineFailed: 'অফলাইন অনুরোধ বাতিল করা যায়নি। রিফ্রেশ করে আবার চেষ্টা করুন অথবা সহায়তায় যোগাযোগ করুন।',
      cancelOfflineSession: 'ওয়ালেট সেশন যাচাই করা যায়নি। পুনরুদ্ধারের আগে সহায়তায় যোগাযোগ করুন।',
      cancelOfflineBalance: 'ওয়ালেটের ব্যালেন্স রেকর্ডের সঙ্গে মিলছে না। পুনরুদ্ধারের আগে সহায়তায় যোগাযোগ করুন।',
      cancelOfflineMissing: 'ওয়ালেটটি পাওয়া যায়নি।',
      cancelOfflineAccount: 'আপনার অ্যাকাউন্ট স্থগিত বা অনুপলব্ধ।',
      cancelOfflinePending: 'শুধু অপেক্ষমাণ অফলাইন অনুরোধ বাতিল করা যায়।',
      cancelOfflineExpired: 'অফলাইন অনুরোধ বাতিলের সময়সীমা শেষ হয়েছে।',
      cancelOfflineSnapshot: 'এই অফলাইন অনুরোধের নিরাপদ পুনরুদ্ধার রেকর্ড নেই। পুরোনো অনুরোধ অথবা অফলাইন হওয়ার আগেই নিষ্ক্রিয় থাকা ওয়ালেট স্বয়ংক্রিয়ভাবে পুনরুদ্ধার করা যায় না। সহায়তায় যোগাযোগ করুন।',
      cancelOfflineRestricted: 'সেটেলমেন্ট, উত্তোলন অথবা ঝুঁকি যাচাইয়ের কারণে এই ওয়ালেট পুনরুদ্ধার করা যাচ্ছে না।',
      cancelOfflineUnavailable: 'ওয়ালেটটি অনুপলব্ধ অথবা অন্য বিধিনিষেধ রয়েছে। সহায়তায় যোগাযোগ করুন।',
      network: 'নেটওয়ার্ক সমস্যা। আবার চেষ্টা করুন।',
      busy: 'সার্ভিস ব্যস্ত। আবার চেষ্টা করুন।'
    }
  }
};

function getMessage(locale, path) {
  return path.split('.').reduce((node, key) => (node && node[key] !== undefined ? node[key] : ''), messages[locale]);
}

module.exports = {
  localeOptions,
  messages,
  getMessage
};
